import { useState, useEffect } from 'react';
import { CreatableMultiselect, Multiselect } from './Multiselect';
import { components } from './reactSelectComponents';
import { MultiValueProps } from 'react-select';
import {
  SortableComponent,
  SortableComponentContainer,
} from '@ardoq/react-sortable-hoc';
import { SelectOption, SortableMultiselectProps } from '../types';
import { getDefaultSelectProps, useMenuPortal } from './GenericSelect';

const arrayMove = <T,>(array: T[], fromIndex: number, toIndex: number): T[] => {
  const arrayCopy = [...array];
  arrayCopy.splice(toIndex, 0, arrayCopy.splice(fromIndex, 1)[0]);
  return arrayCopy;
};

const SortableMultiValue = SortableComponent(
  // TODO this is still a bit broken
  (props: MultiValueProps<SelectOption<any>> & { isDeletable?: boolean }) => (
    <components.MultiValue
      {...props}
      showDragHandle={true}
      onMouseDown={evt => {
        evt.preventDefault();
        evt.stopPropagation();
      }}
    />
  )
);

const SortableSelect = SortableComponentContainer(Multiselect);
const SortableCreatableSelect =
  SortableComponentContainer(CreatableMultiselect);

const SortableMultiselect = <TValue,>(
  props: SortableMultiselectProps<TValue>
) => {
  // TODO This is a bit broken I think, TO BE DISCOVERED
  // but I think value can be a type of number eg "1" or a type of option
  // { label: 'one', value: "1" }
  const propValue = props.value as unknown as SelectOption<TValue>[];
  const defaultSelectProps = getDefaultSelectProps(props);
  const { menuPortalTarget, menuPosition } = useMenuPortal(
    props.menuPortalTarget,
    props.menuPosition
  );
  const [selected, setSelected] = useState<SelectOption<TValue>[]>(
    propValue || []
  );

  useEffect(() => {
    setSelected(propValue);
  }, [propValue]);

  const handleUpdate = (selectedOptions: SelectOption<TValue>[]) => {
    setSelected(selectedOptions);
    if (typeof props.onChange === 'function') {
      props.onChange(selectedOptions);
    }
  };

  const Component = props.isCreatable
    ? SortableCreatableSelect
    : SortableSelect;

  return (
    <Component
      {...defaultSelectProps}
      isMulti
      value={selected}
      components={{
        ...defaultSelectProps.components,
        // @ts-expect-error todo
        MultiValue: (innerProps: MultiValueProps<SelectOption<TValue>>) => (
          <SortableMultiValue
            {...innerProps}
            isDeletable={props.isDeletable}
            dragTargetClass="react-sortable-drag-target"
          />
        ),
      }}
      {...props}
      menuPortalTarget={menuPortalTarget}
      menuPosition={menuPosition}
      onChange={selectedOptions =>
        handleUpdate(selectedOptions as SelectOption<TValue>[])
      }
      // react-sortable-hoc props:
      onSortEnd={({ oldIndex, newIndex }) =>
        handleUpdate(arrayMove(selected, oldIndex, newIndex))
      }
    />
  );
};

export { SortableMultiselect };
